const KEY = "lang";

const ERRORS = {
  "Noe gikk galt. Prøv igjen.": "Something went wrong. Please try again.",
  "Noe gikk galt": "Something went wrong",
  "E-posten er allerede registrert med et annet telefonnummer": "This email is already registered with a different phone number",
  "Fant ikke kunden": "Customer not found",
  "Fant ingen registrering med denne e-posten og dette telefonnummeret": "No registration found with this email and phone number",
  "For mange forsøk. Be om en ny kode.": "Too many attempts. Please request a new code.",
  "Ikke innlogget": "Not logged in",
  "Innloggingen er utløpt": "Your login has expired",
  "Koden er allerede brukt": "The code has already been used",
  "Koden er utløpt og kan ikke brukes": "The code has expired and cannot be used",
  "Koden er utløpt. Be om en ny kode.": "The code has expired. Please request a new code.",
  "Koden er utløpt. Start innloggingen på nytt.": "The code has expired. Please start the login again.",
  "Koden er utløpt. Start registreringen på nytt.": "The code has expired. Please start the registration again.",
  "Kunne ikke sende SMS. Sjekk telefonnummeret.": "Could not send SMS. Please check the phone number.",
  "Kunne ikke sende kode til e-posten. Sjekk at e-postadressen er riktig.": "Could not send the code to your email. Please check the address.",
  "Kupongen ble ikke funnet": "Coupon not found",
  "Kupongen er utløpt": "The coupon has expired",
  "Kupongen kan først brukes fra i morgen": "The coupon can be used from tomorrow",
  "Kupongen må aktiveres først": "The coupon must be activated first",
  "SMS er ikke tilgjengelig akkurat nå": "SMS is not available right now",
  "Ugyldig forespørsel": "Invalid request",
  "Ugyldig innlogging": "Invalid login",
  "Ugyldig norsk telefonnummer": "Invalid Norwegian phone number",
  "Feil kode. Be om en ny kode.": "Wrong code. Please request a new code.",
  "Du må godta vilkårene": "You must accept the terms",
  "Fornavn må ha minst 2 tegn": "First name must be at least 2 characters",
  "Fødselsdato kan ikke være i fremtiden": "Date of birth cannot be in the future",
  "Ugyldig fødselsdato": "Invalid date of birth",
  "Telefonnummeret er allerede registrert. Logg inn med telefonnummeret i stedet.": "This phone number is already registered. Please log in with your phone number instead.",
  "Du har allerede en aktiv kupong. Bruk den først, eller vent til den utløper.": "You already have an active coupon. Use it first, or wait until it expires.",
};

const PATTERNS = [
  [/^Feil kode\. (\d+) forsøk igjen\.$/, (m) => `Wrong code. ${m[1]} attempts left.`],
  [/^Vent (\d+) sekunder før du sender på nytt$/, (m) => `Please wait ${m[1]} seconds before resending`],
  [/^Value error, (.+)$/, (m) => translateError(m[1], "en")],
];

export function translateError(msg, lang) {
  if (lang !== "en" || typeof msg !== "string") return msg;
  if (ERRORS[msg]) return ERRORS[msg];
  for (const [re, fn] of PATTERNS) {
    const m = msg.match(re);
    if (m) return fn(m);
  }
  return msg;
}

export const storedLang = () => (localStorage.getItem(KEY) === "en" ? "en" : "no");
export const saveLang = (l) => localStorage.setItem(KEY, l);
export const currentLang = () => (window.location.pathname.startsWith("/admin") ? "no" : storedLang());
